import { ReactNode, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import { Button, Stack, SxProps, Theme, Typography } from '@mui/material'
import { SimpleModal } from 'simple_modal'
import { Spacer2 } from 'spacer'

type Props = {
  shouldBlock?: boolean
  children: ReactNode
  promptTitle: string
  promptContent: string
  proceedText: string
  goBackText: string
  sx?: SxProps<Theme>
}

export const NavBlocker = ({
  shouldBlock = true,
  promptTitle,
  promptContent,
  proceedText,
  goBackText,
  children,
  sx,
}: Props) => {
  // use custom blocker for route changes
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => shouldBlock && currentLocation.pathname !== nextLocation.pathname
  )

  useEffect(() => {
    const onBeforeUnload = (ev: BeforeUnloadEvent) => {
      if (shouldBlock) {
        ev.preventDefault()
        ev.returnValue = ''
      }
    }
    // use browser blocker for all other cases that are not covered by useBlocker
    window.addEventListener('beforeunload', onBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload)
    }
  }, [shouldBlock])

  return (
    <>
      {children}
      <SimpleModal sx={sx} open={blocker.state === 'blocked'}>
        <Typography variant="h5">{promptTitle}</Typography>
        <Spacer2 />
        <Typography variant="body1">{promptContent}</Typography>
        <Spacer2 />
        <Stack direction="row" spacing={2}>
          <Button variant="contained" color="secondary" onClick={() => blocker.proceed?.()}>
            {proceedText}
          </Button>
          <Button onClick={() => blocker.reset?.()}>{goBackText}</Button>
        </Stack>
      </SimpleModal>
    </>
  )
}
